'use client'

import LanguageSwitcher from '@/components/extension/language-switcher'
import { Container } from '@/components/ui/container'
import { LAYOUT_CONFIG } from '@/lib/config/layout'
import { cn } from '@/lib/utils'
import { useTranslations } from 'next-intl'
import Link from 'next/link'

const isDisabledLocale = process.env.NEXT_PUBLIC_LOCALE_DISABLED

export function TopBar({ isScrollingDown }: { isScrollingDown: boolean }) {
  const t = useTranslations('header')

  return (
    <div
      className={cn(
        'h-8 transition-all duration-200',
        isScrollingDown && 'm-0 h-0 scale-y-95 overflow-hidden p-0'
      )}
      aria-hidden={isScrollingDown}
    >
      <Container
        size='full'
        className='flex h-8 items-center justify-center bg-neutral-500 lg:justify-between'
      >
        <ul className='flex h-full items-center justify-evenly max-lg:flex-1 md:justify-between'>
          {LAYOUT_CONFIG.HEADER.TOP_BAR.LEFT.map((item, index, arr) => (
            <li
              key={index}
              className='relative flex h-full flex-auto items-center lg:flex-none'
            >
              <Link
                href={item.href}
                aria-label={item.title}
                className='block h-full flex-1 whitespace-nowrap px-1 py-2 pt-2.5 text-center font-criteria text-[10px] font-medium leading-3.5 text-neutral-200 transition-colors hover:bg-neutral-600 lg:px-2 lg:text-xs'
                prefetch={false}
                // replace . with __
                ga-tracking-value={`${item.title.replace(/\./g, '__')}`}
                ga-tracking-label={t(item.title)}
              >
                {t(item.title)}
              </Link>
              <span
                className={cn(
                  'absolute right-0 z-10 my-2 block h-4.5 w-[1px] bg-neutral-300/20',
                  index === arr.length - 1 && 'hidden'
                )}
              ></span>
            </li>
          ))}
        </ul>

        <ul className='hidden h-full items-center justify-evenly max-lg:flex-1 md:justify-between lg:flex'>
          {LAYOUT_CONFIG.HEADER.TOP_BAR.RIGHT.map((item, index) => (
            <li
              key={index}
              className='relative flex h-full flex-1 items-center lg:flex-none'
            >
              <Link
                href={item.href}
                prefetch={false}
                target={item.target}
                className='flex h-full flex-1 items-center gap-0.5 whitespace-nowrap px-2 py-2 pt-2.5 text-center font-criteria text-xs font-medium leading-3.5 text-neutral-200 transition-colors hover:bg-neutral-600'
                ga-tracking-value={`${item.title.replace(/\./g, '__')}`}
                ga-tracking-label={t(item.title)}
              >
                {t(item.title)}
              </Link>
              <span className='absolute right-0 z-10 my-2 block h-4.5 w-[1px] bg-neutral-300/20'></span>
            </li>
          ))}
          {!isDisabledLocale && (
            <LanguageSwitcher
              gaTrackingValue='topbar__right__language_switcher'
              gaTrackingLabel='Language Switcher'
            />
          )}
        </ul>
      </Container>
    </div>
  )
}
